import React, { useMemo } from "react";
import { NavLink } from "react-router-dom";
import { useLocaleContext } from "../../context/LocaleContext";
import { usePollsContext } from "../../context/PollsContext";
import QuizPartner from "./QuizPartner";
import { CButton } from "../UI";

function getPointsLabel(quantity) {
    const lastDigit = quantity % 10;
    const lastTwoDigits = quantity % 100;

    if (lastDigit === 1 && lastTwoDigits !== 11) {
        return `point.1`;
    } else if (lastDigit >= 2 && lastDigit <= 4 && (lastTwoDigits < 12 || lastTwoDigits > 14)) {
        return `point.2`;
    } else {
        return `point.5`;
    }
}

export default ({ quiz }) => {
    const $locale = useLocaleContext();

    if (!quiz) return null;

    const { backgroundImageUrl, displaySize, textColor } = quiz;
    const { answeredPollIds } = usePollsContext();


    const style = {
        '--quiz-text-color': textColor ? `#${textColor}` : undefined,
        backgroundColor: `#${quiz.backgroundColor || '888888'}`,
        backgroundImage: backgroundImageUrl ? `url(${backgroundImageUrl})` : undefined,
        width: displaySize > 100 ? `${displaySize}px` : undefined,
    };

    let className = 'quiz-article';

    if (displaySize === 0) {
        className += ` ${className}-span-wide`;
    } else if (displaySize > 0) {
        className += ` ${className}-span-${displaySize}`;
    }

    const isQuizCompleted = useMemo(() => {
        return quiz.polls.every(({ id }) =>  answeredPollIds.includes(id));
    }, [quiz, answeredPollIds]);

    const handlerOpenQuiz = (event) => {
        if (isQuizCompleted) {
            event.preventDefault();
        }
    };

    return (
        <article className={className} style={style}>
            <div>
                {quiz.posterUrl && <img className={"quiz-poster"} src={quiz.posterUrl} />}
                <main className="quiz-main">
                    <div className="quiz-title">{$locale.getProperty(quiz, "title")}</div>
                    <div className="quiz-description">{$locale.getProperty(quiz, "description")}</div>
                </main>
                <div
                    className={"quiz-partners" + (quiz.partnersDisplay ? ` quiz-partners-${quiz.partnersDisplay}` : "")}
                >
                    {quiz.partners.map((partner) => (
                        <QuizPartner key={partner.id} partner={partner} />
                    ))}
                </div>
            </div>
            <div>
                <NavLink
                    to={`${window.location.pathname}?active-quiz-key=${quiz.quizKey}`}
                    className="quiz-join-link-wrapper"
                    onClick={handlerOpenQuiz}
                >
                    <CButton
                        label={isQuizCompleted ? $locale.get("quiz.completed") : ($locale.getProperty(quiz, "buttonText") || $locale.get("quiz.joinButton"))}
                        size="lg"
                        colorFilled={'#' + (quiz.buttonColor || '999999')}
                        disabled={isQuizCompleted}
                    />
                </NavLink>
                {quiz.showPointsQuantity && (
                    <div className="quiz-points">
                        {quiz.pointsQuantity} {$locale.get(`quiz.quantity.${getPointsLabel(quiz.pointsQuantity)}`)}
                    </div>
                )}
            </div>
        </article>
    );
};
